module.exports = __webpack_public_path__ + "files/64d5329ddaa525a744acb34cbb3c5d13.png";